<template>
    <div class="vantBody">
        <div class="viewImg">
            <img src="@/assets/activity/icon1.jpg" alt="">
            <img src="@/assets/activity/icon2.jpg" alt="">
            <img src="@/assets/activity/icon3.jpg" alt="">
            <img src="@/assets/activity/icon4.jpg" alt="">
            <img src="@/assets/activity/icon5.jpg" alt="">
        </div>
        <div class="el-btn">
            <van-button round type="info" class="btnButton" @click="sunmbitFn()">立即免费领取</van-button>
            <div class="template-enhance-animation-light"></div>
        </div>
        <!--底部显示输入框-->
        <van-popup v-model="show" round :closeable="true" position="bottom" class="bottom-popup">
            <div class="form-tips">收货人信息</div>
            <div class="small">根据国家实名要求，请填写以下的信息，以便我们及时给您送达</div>
             <van-cell-group>
                <van-field  v-model="dataFrom.takeNickname" :required="true"  clearable  label="姓名" placeholder="请输入姓名"  />
                <van-field v-model="dataFrom.takePhone" :required="true" maxlength="11" clearable label="手机号" placeholder="请输入11位手机号" />
                <van-field v-model="dataFrom.smsCode" center :required="true" clearable label="验证码" placeholder="请输入短信验证码">
                    <template #button>
                        <van-button size="small" type="primary" :disabled="dataFrom.takePhone.length!==11 || !countdown" @click="obtainCode">
                            <span v-if="countdown">{{text}}</span>
                            <span v-if="!countdown">{{text}} ({{count}})</span>
                        </van-button>
                    </template>
                </van-field>
                <van-field v-model="dataFrom.pcaAddress" :required="true" maxlength="11" clearable label="省市区" placeholder="请选择省市区" @focus="showAddressVisible()"/>
                <van-field v-model="dataFrom.takeAddress" :required="true" maxlength="11" clearable label="详细地址" placeholder="请输入详细地址" />
            </van-cell-group>
            <van-popup v-model="dataFrom.addressVisible" position="bottom">
                <van-area
                    :area-list="areaList"
                    :columns-placeholder="['请选择', '请选择', '请选择']"
                    @cancel="cancelSelectAddress()"
                    @confirm="selectAddress"
                />
            </van-popup>
            <div class="checkbox-info">
                <van-checkbox v-model="checked"></van-checkbox> 
                <span style="color:#007AFF;cursor: pointer;">阅读并同意(注意: 领取即表示同意服务协议及声明)</span>
                <div @click="cccc()" style="color:#007AFF;cursor: pointer;margin-left:30px;">《个人信息授权及保护声明》</div>
            </div>
            <div class="sumbit">
                <van-button round type="info" class="sumbitSave" @click="sumbitSave()">立即免费领取</van-button>
                <div class="template-enhance-animation-light"></div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
import { Dialog } from 'vant';
export default {
    data(){
        return{
            checked:false,
            show:false,
            dataFrom:{
               takeNickname:'' ,
               addressVisible:false,
               takePhone:'',
               takeAddress:'',
               changeCmccSim:'1',
               pcaAddress:'',
               smsCode:'',
               oldIccid:'1',
               agentId:''
            },
            timer: null,
            text:"获取验证码",
            count: "",
            countdown: true,
            areaList:areaListData,
        }
    },
    methods:{
        sunmbitFn(){
            this.show=true
        },
        sumbitSave(){
            if(!this.checked){
                Toast.fail('请勾选个人信息收集证明协议');
                return
            }
            if(!this.dataFrom.takeNickname ){
                Toast.fail('请填写姓名');
                return;
            }
            if(!this.dataFrom.takePhone ){
                Toast.fail('请填写手机号');
                return;
            }
            if(!this.dataFrom.pcaAddress ){
                Toast.fail('请填写省市区');
                return;
            }
            if(!this.dataFrom.takeAddress ){
                Toast.fail('请填写详细地址');
                return;
            }
            if(!this.dataFrom.smsCode ){
                Toast.fail('请填写验证码');
                return;
            }
            if(this.dataFrom.takePhone && !(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.dataFrom.takePhone))){
                Toast.fail('请填写正确的手机号');
                return;
            }
            wxRequest('applyChangeSim/apply/sim/my', this.dataFrom, 'post').then(res => {
                if(res.data.code == 200){
                  _ks_trace.push({event: 'form', convertId: 443682, cb: function(){    
                      
                  }})
                    Toast.success(res.data.message);
                    this.dataFrom={
                        takeNickname:'' ,
                        addressVisible:false,
                        takePhone:'',
                        smsCode:'',
                        takeAddress:'',
                        changeCmccSim:1,
                        pcaAddress:'',
                    }
                     this.show=false
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        //获取验证码
        obtainCode(){
            if(!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.dataFrom.takePhone))){
                Toast.fail('请填写正确的手机号');
                return;
            }
            const rulut = this.$getRsaCode(this.dataFrom.takePhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code/auth", data, "post").then(res => {
                if(res.data.code == 200){
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.countdown = false;
                        this.text="重新发送"
                        this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.countdown = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                        }, 1000);
                    }
                }else{
                    Toast.fail(res.data.message);
                }
            })
        },
        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.dataFrom.addressVisible = false;
        },
        showAddressVisible() {
            this.dataFrom.addressVisible = true;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name + values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name + values[1].name + values[2].name;
            }
            this.dataFrom.addressVisible = false;
        },
        cccc(){
            Dialog.confirm({
            title: '《个人信息授权及保护声明》',
            width:'90%',
            showCancelButton:false,
            messageAlign:'left',
            confirmButtonColor:'#ee0a24',
            message: `关于客户个人信息收集、使用规则的公告
        尊敬的客户：
        《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在中国电信股份有限公司各类营业网点（含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等）办理固定电话、移动电话（含无线上网卡）入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。
        如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。
        为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外泄露客户个人信息：
        (a)事先获得客户的明确授权；
        (b)根据有关的法律法规要求；
        (c)按照相关司法机关和/或政府主管部门的要求；
        (d)为维护社会公众的利益所必需且适当；
        (e)为维护我公司或客户的合法权益所必需且适当。`,
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="less" scoped>
    
    .vantBody{
        max-width:540px;
        margin:0 auto;
        height: 100%;
        position: relative;
        .viewImg{
            img{
                height:100%;
                width:100%;
                display: block;
            }
        }
        .el-btn{
            position: fixed;
            width:100%;
            height:70px;
            background:#fff;
            bottom:0;
            text-align: center;
            line-height: 60px;
            .btnButton{
                width: 92%;
                text-align: center;
                height:50px;
                line-height: 78px;
                color: #fff;
                background-image:-webkit-linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
                background-image:linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
                font-size: 18px;
                border: none;
                -webkit-animation: templateEnlargeShrink 3s infinite;
                -o-animation: templateEnlargeShrink 3s infinite;
                animation: templateEnlargeShrink 3s infinite;
                border-radius: 25px;
            }
            .template-enhance-animation-light{
                background: url(../../assets/activity/light_animate.png);
                position: absolute;
                top:10px;
                width: 6.1625rem;
                height: 3rem;
                animation: templateSearchLights 3s linear infinite forwards;
                -webkit-transform-style: preserve-3d;
                -webkit-backface-visibility: hidden;
                -webkit-perspective: 1000;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                background-size: 6.1625rem 3.8125rem;
            }
        }
        .sumbit{
            text-align: center;
            padding:8px 0;
            position: relative;
            .sumbitSave{
                width: 92%;
                text-align: center;
                height:50px;
                line-height: 78px;
                background-image:-webkit-linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
                background-image:linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
                 -webkit-animation: templateEnlargeShrink 3s infinite;
                -o-animation: templateEnlargeShrink 3s infinite;
                animation: templateEnlargeShrink 3s infinite;
                border: none;
                color: #fff;
                font-size: 18px;
                border-radius: 25px;
            }
            .template-enhance-animation-light{
               background: url(../../assets/activity/light_animate.png);
                position: absolute;
                top:10px;
                width: 6.1625rem;
                height: 3rem;
                animation: templateSearchLights 3s linear infinite forwards;
                -webkit-transform-style: preserve-3d;
                -webkit-backface-visibility: hidden;
                -webkit-perspective: 1000;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                background-size: 6.1625rem 3.8125rem;
            }
        }
        .bottom-popup{
            padding:40px 0 10px 0;
            .van-cell-group{
                margin:0 auto;
                &::after{
                    border:none
                }
            }
        }
        .small{
            font-size:10px;
            padding:6px 16px 10px 16px;
            color:#666;
        }
        .form-tips{
            width: 80px;
            height: 30px;
            line-height: 30px;
            padding-left: 15px;
            padding-bottom:2px;
            font-size:15px;
            font-weight:600;
            background: url('../../assets/activity/icon6.png') no-repeat left bottom;
            background-size:100%;
            color: #333;
            border-radius: 15px;
            margin-bottom:6px;
        }
        .checkbox-info{
            width: 93%;
            margin: 10px auto;
            font-size:12px;
            color:#fff;
            .van-checkbox{
                display: inline-block;
                vertical-align: middle;
                margin-right:10px;
            }
        }
    }
    @keyframes templateEnlargeShrink {
        0% {
            transform: scale(1);
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
        }
        33% {
            transform: scale(0.95);
            -webkit-transform: scale(0.95);
            -ms-transform: scale(0.95);
        }
        66% {
            transform: scale(1);
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
        }
        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
        }
    }
    @keyframes templateSearchLights {
        0% {
            transform: translate(-5.66123188rem);
            -webkit-transform: translate(-5.66123188rem);
            opacity: 0;
        }
        66% {
            transform: translate(-5.66123188rem);
            -webkit-transform: translate(-5.66123188rem);
            opacity: 1;
        }
        100% {
            transform: translate(24.90942029rem);
            -webkit-transform: translate(24.90942029rem);
        }
    }
    
</style>